import { FilterProps } from "components/Filters";
import { CheckboxListFilter } from "components/Filters/GenericFilters/CheckboxListFilter";
import { useContractDetailsSelects } from "contexts/ContractDetailsSelectsProvider";
import { sortObjectsByProperty } from "./sortFilterOptions";

export const ContractDetailsShipToFilter = ({ variant }: FilterProps) => {
  const selectStates = useContractDetailsSelects();

  const shipTo = selectStates.find(({ filterKey }) => filterKey === "shipTo");

  const shipToOptions = shipTo
    ? sortObjectsByProperty(shipTo.options, "label")
    : [];

  return (
    <CheckboxListFilter
      filterKey="shipTo"
      name="Ship To"
      variant={variant}
      filterOptions={shipToOptions}
      maxH="200px"
    />
  );
};
